import { render, staticRenderFns } from "./reminderSettings.vue?vue&type=template&id=51296b4f&scoped=true&"
import script from "./reminderSettings.vue?vue&type=script&lang=js&"
export * from "./reminderSettings.vue?vue&type=script&lang=js&"
import style0 from "./reminderSettings.vue?vue&type=style&index=0&id=51296b4f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51296b4f",
  null
  
)

export default component.exports